const Utils = {
  objectValues: <T = any>(x: { [index: string]: T }): T[] => {
    return Object.keys(x).map((key: string) => {
      return x[key];
    });
  },
};

export default Utils;
